<template>
	<div id="page-user-edit">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('Alarm.RadioAlarm')"
			:subTitle="
				($t('general.SubtitleAlarmSchedule') +
					' ' +
					$t('general.SubtitleAlarmSchedule1') +
					' ' +
					$t('Alarm.Radio') +
					' ' +
					$t('general.SubtitleAlarmSchedule2'))
					| upperAndLowerFilter
			"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		></bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<radio-alarm-list
					v-if="alarmReadPermission"
					@selectedAlarmEmit="selectedAlarmEmit"
					@valueCreateSchelude="valueAlarmZoneEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<alarm-form
					v-if="alarmCreatePermission && alarmData.key === ''"
					ref="alarmFormRef"
					type="AlarmRadio"
					:data="alarmData"
					@handleSubmitEmit="handleSubmit"
					@changeActiveTabEmit="valueAlarmZoneEmit"
				/>
				<alarm-form
					v-else-if="alarmUpdatePermission && alarmData.key !== ''"
					ref="alarmFormRef"
					type="AlarmRadio"
					:data="alarmData"
					:duplicate="duplicate"
					@handleSubmitEmit="handleSubmit"
					@changeActiveTabEmit="valueAlarmZoneEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
		</div>
	</div>
</template>
<script>
import moduleAlarm from "@/store/alarm/moduleAlarm.js";
import AlarmForm from "../AlarmForm.vue";
import NotPermission from "@/views/pages/NotPermission.vue";
import RadioAlarmList from "@/components/alarm/radio/RadioAlarmList.vue";
import AlarmRadio from "@/models/AlarmRadio";

export default {
	components: {
		RadioAlarmList,
		AlarmForm,
		NotPermission,
	},
	data() {
		return {
			alarmData: new AlarmRadio({}),
			user_not_found: false,
			activeTab: 0,
			duplicate: false,
		};
	},
	computed: {
		nameTabOne() {
			return this.alarmData.key !== "" ? this.$t("Alarm.UpdateAlarm") : this.$t("Alarm.CreateAlarm");
		},
		alarmReadPermission() {
			return this.$store.getters.checkPermission("ALARMS_R");
		},
		alarmCreatePermission() {
			return this.$store.getters.checkPermission("ALARMS_C");
		},
		alarmUpdatePermission() {
			return this.$store.getters.checkPermission("ALARMS_U");
		},
	},
	watch: {
		activeTab(tabNum) {
			if (tabNum === 0) {
				this.alarmData = new AlarmRadio({});
			}
		},
	},
	methods: {
		handleSubmit(data, update, duplicate = false) {
			this.alarmData = data;
			this.alarmData.radius = parseInt(data.radius);
			if (this.alarmData.radius < 0 || this.alarmData.radius > 1000) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("Alarm.MissingFields.Title"),
					text: this.$t("Alarm.MissingFields.Text"),
				});
				return;
			}
			this.$refs.alarmFormRef.openLoadingBtn();
			if (update && !duplicate) {
				this.$store
					.dispatch("moduleAlarm/updateRadioAlarm", this.alarmData)
					.then((res) => {
						this.valueAlarmZoneEmit(0);
						this.$vs.notify({
							color: "success",
							title: this.$t("Alarm.TitleConfirmAlarmUpdate"),
							text: this.$t("Alarm.TextConfirmAlarmUpdate"),
						});
						this.$refs.alarmFormRef.closeLoadingBtn();
					})
					.catch((err) => {
						this.$refs.alarmFormRef.closeLoadingBtn();
						this.$vs.notify({
							color: "danger",
							title: this.$t("ErrorTitle"),
							text: this.$t("ErrorMessage"),
						});
						throw new Error(err);
					});
			} else {
				delete this.alarmData.key;
				delete this.alarmData.company_id;
				delete this.alarmData.created_at;
				this.$store
					.dispatch("moduleAlarm/createRadioAlarm", this.alarmData)
					.then((res) => {
						this.$vs.notify({
							color: "success",
							title: this.$t("Alarm.TitleConfirmAlarmCreate"),
							text: this.$t("Alarm.TextConfirmAlarmCreate"),
						});
						this.valueAlarmZoneEmit(0);
						this.$refs.alarmFormRef.closeLoadingBtn();
					})
					.catch((err) => {
						this.$refs.alarmFormRef.closeLoadingBtn();
						this.$vs.notify({
							color: "danger",
							title: this.$t("ErrorTitle"),
							text: this.$t("ErrorMessage"),
						});
						throw new Error(err);
					});
			}
		},
		selectedAlarmEmit(alarm, duplicate = false) {
			this.alarmData = new AlarmRadio(alarm);
			this.activeTab = 1;
			this.duplicate = duplicate;
		},
		valueAlarmZoneEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.alarmData = new AlarmRadio({});
			}
		},
	},
	created() {
		if (!moduleAlarm.isRegistered) {
			this.$store.registerModule("moduleAlarm", moduleAlarm);
			moduleAlarm.isRegistered = true;
		}
	},
	mounted() {},
};
</script>
